import { defineStore } from 'pinia';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '@/firebase';  // Asegúrate de importar db desde Firebase
import { collection, getDocs } from 'firebase/firestore'; // Importa funciones de Firestore

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null,
    isAuthenticated: false,
    users: [],  // Añadimos un estado para almacenar todos los usuarios
  }),
  actions: {
    setUser(user) {
      this.user = user;
      this.isAuthenticated = true;
    },
    logout() {
      this.user = null;
      this.isAuthenticated = false;
    },
    async fetchUsers() {
      try {
        // Obtiene todos los usuarios de la colección "users"
        const usersQuery = collection(db, 'users');
        const querySnapshot = await getDocs(usersQuery);

        this.users = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
      } catch (error) {
        console.error("Error al obtener los usuarios:", error);
      }
    },
    checkAuth() {
      return new Promise((resolve) => {
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            this.setUser(user);
            await this.fetchUsers();  // Llamar a fetchUsers cuando el usuario está autenticado
          } else {
            this.clearUser();
          }
          resolve(this.isAuthenticated);
        });
      });
    },
    clearUser() {
      this.user = null;
      this.isAuthenticated = false;
      this.users = [];  // Limpiar los usuarios cuando no hay sesión activa
    },
  },
});